const ErrorState = ({ message, description, onBack }) => (
  <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
    <div className="text-center">
      <h2 className="mb-2 text-2xl font-bold text-red-600 dark:text-red-400">
        {message}
      </h2>
      <p className="text-white">{description}</p>
      <button
        onClick={onBack}
        className="mt-4 rounded-lg bg-blue-600 px-6 py-2 text-white transition-colors hover:bg-blue-700"
      >
        Go Back
      </button>
    </div>
  </div>
);

export default ErrorState;
